class VideosPlayer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initVideoPlayer();
    }

    initVideoPlayer() {
        const youtubeWrapper = this.querySelector('[data-type="youtube"]');
        const fileVideo = this.querySelector('video[data-type="file"]');

        if (youtubeWrapper) {
            this.initYouTubePlayer(youtubeWrapper);
        } else if (fileVideo) {
            this.initFilePlayer(fileVideo);
        } else {
            // console.warn('未找到合适的视频元素。');
        }
    }

    initYouTubePlayer(youtubeWrapper) {
        const iframe = youtubeWrapper.nextElementSibling;
        const youtubeClickHandler = () => {
            this.classList.add('active');
            const src = iframe.getAttribute('data-src');
            const newIframe = document.createElement('iframe');
            newIframe.src = `${src}&autoplay=1`;
            newIframe.frameborder = "0";
            newIframe.allow = "autoplay; encrypted-media";
            newIframe.allowFullscreen = true;
            iframe.parentNode.replaceChild(newIframe, iframe);
            // console.log('YouTube 视频播放已开始。');
            youtubeWrapper.removeEventListener('click', youtubeClickHandler);
        };
        youtubeWrapper.addEventListener('click', youtubeClickHandler);
    }

    initFilePlayer(fileVideo) {
        const fileVideoClickHandler = () => {
            this.classList.add('active');
            setTimeout(() => {
                fileVideo.play();
                fileVideo.setAttribute('controls', 'controls');
                // console.log('文件视频播放已开始，并显示控制面板。');
            }, 50);
            fileVideo.removeEventListener('click', fileVideoClickHandler);
        };
        fileVideo.addEventListener('click', fileVideoClickHandler);
    }
}

customElements.define('videos-player', VideosPlayer);